import Fund from '@/models/Fund';

export default class Segment {
  static getScript(segmentId: string) {
    return `
    !function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var t=analytics.methods[e];analytics[t]=analytics.factory(t)}analytics.load=function(e,t){var n=document.createElement("script");n.type="text/javascript";n.async=!0;n.src="https://cdn.segment.com/analytics.js/v1/"+e+"/analytics.min.js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(n,a);analytics._loadOptions=t};analytics.SNIPPET_VERSION="4.1.0";
    analytics.load("${segmentId}");
    }}();`;
  }

  static appendScript(segmentId: string) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = this.getScript(segmentId);
    document.head.appendChild(script);
  }

  static setAnalyticsPage(
    name: string,
    category?: string,
    properties?: object
  ) {
    if (category) {
      window?.analytics?.page(category, name, {
        path: `${category}-${name}`,
        ...properties
      });
    }
    if (!category) {
      window?.analytics?.page(name, {
        ...properties
      });
    }
  }

  static setIdentificationToken(id: string | null, properties?: object) {
    if (id) window?.analytics?.identify(id, properties);
  }

  static resetAnalytics() {
    const ajsAnonymousId = window?.localStorage?.getItem('ajs_anonymous_id');
    const anonymousId = JSON.parse(ajsAnonymousId ? ajsAnonymousId : 'null');
    window?.analytics?.reset();
    window?.analytics?.setAnonymousId(anonymousId);
  }

  static removeAnalytics() {
    this.resetAnalytics();
    window.analytics = null;
  }

  static reInitAnalytics(segmentId: string) {
    if (!window.analytics) {
      this.appendScript(segmentId);
    }
  }

  static trackAction(actionName: string, actionProperties?: object) {
    const title = document.title;
    document.title = title.split('-')[0];
    window?.analytics?.track(actionName, actionProperties);
    document.title = title;
  }

  static trackSubmissionEvent(
    eventName: string,
    submissionContext: {
      investmentId: string;
      submissionId: string;
      strategyName: string;
      organizationTypeSlug: string;
      fund: Fund;
    },
    extraProps?: any
  ) {
    let strategyName = submissionContext?.fund?.productType?.name ?? '';
    if (submissionContext?.fund?.subStrategy?.name && strategyName) {
      strategyName = `${strategyName} - ${submissionContext?.fund?.subStrategy.name}`;
    }

    this.trackAction(eventName, {
      investment_id: submissionContext?.investmentId,
      submission_id: submissionContext?.submissionId,
      strategyName: submissionContext?.strategyName,
      organization_type: submissionContext?.organizationTypeSlug,
      ...extraProps
    });
  }
}

declare global {
  interface Window {
    analytics: any;
  }
}
